/**
 * Navigation Store Module
 */

// Types
import * as types from '../types'

// State
const state = {
	nav: {
		open: false,
		items: {
			// home: {
			// 	label: 'Dashboard',
			// 	title: 'View Dashboard',
			// },
			content: {
				label: 'Content',
				title: 'Manage Site Content',
			},
			model: {
				label: 'Models',
				title: 'Manage Content Models',
			},
		},
	},
}

// Actions
const actions = {
	navToggle: ({ commit }, toggle) => {
		commit(types.NAV_TOGGLE, toggle)
	},
}

// Mutations
const mutations = {
	[types.NAV_TOGGLE](state, toggle) {
		if (toggle === undefined) {
			state.nav.open = !state.nav.open
		} else {
			state.nav.open = toggle
		}
	},
}

// Getters
const getters = {
	nav: state => state.nav,
	navState: state => state.nav.open,
	navItems: state => state.nav.items,
}

export default {
	state,
	actions,
	mutations,
	getters,
}



// WEBPACK FOOTER //
// ./src/lib/store/modules/nav.js